import { createContext } from 'react'

export const LinkedInContext = createContext({})
